<template>
    <footer>
    </footer>
</template>
<script>
export default {
    name: 'Foot'
}
</script>
<style scoped>
    footer {
        padding: 40px;
        background-color: rgba(40, 40, 40, 0);
    }
    p {
        color: rgb(245, 245, 245);
        text-align: center;
    }
</style>